import type { TFunction } from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { FilterOption } from '../../../components/filters/filter-panel.type';
import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { setOverviewSelectedStatuses } from '../../../store/strategy-store/strategy-store.actions';
import { primaryBase, redBase, skyDark, yellowBase } from '../../../styles/design-tokens';
import type { FilterGroup } from '../initiative-list/filters/filters.type';
import { getStatusLabels } from '../initiative-list/filters/filters.type';
import { StatusLabel } from '../initiative-list/filters/status-label';
import { Status } from '../strategy.type';

const getObjectiveStatusOptions = (t: TFunction): FilterOption[] => {
  const labels = getStatusLabels(t);
  return [
    {
      value: Status.OnTrack,
      label: <StatusLabel color={primaryBase} label={labels[Status.OnTrack]} />,
    },
    {
      value: Status.AtRisk,
      label: <StatusLabel color={yellowBase} label={labels[Status.AtRisk]} />,
    },
    {
      value: Status.OffTrack,
      label: <StatusLabel color={redBase} label={labels[Status.OffTrack]} />,
    },
    {
      value: Status.Unknown,
      label: <StatusLabel color={skyDark} label={labels[Status.Unknown]} />,
    },
  ];
};

const useFilterGroups = (): FilterGroup[] => {
  const i18n = useTranslation();
  const overviewFilters = useStrategyStore((state) => state.overviewFilters);

  return useMemo(
    () => [
      {
        id: 'objective_status',
        name: i18n.t('strategy.filters.status'),
        icon: 'fact_check',
        options: getObjectiveStatusOptions(i18n.t),
        selectedValues: overviewFilters.selected_statuses,
        onSelectionChange: setOverviewSelectedStatuses,
      },
    ],
    [overviewFilters, i18n.t],
  );
};

export { useFilterGroups };
